import React from 'react';
import ContactSection from '../components/ContactSection';  

const services = [
  {
    id: 1,
    title: 'Data Science',
    description: 'Providing comprehensive data analysis and insights to help businesses make informed decisions.',
    icon: '📊',
  },
  {
    id: 2,
    title: 'Machine Learning',
    description: 'Building and deploying machine learning models to automate tasks and improve business operations.',
    icon: '🤖',
  },
  {
    id: 3,
    title: 'Generative AI Product Development',
    description: 'Creating innovative AI-driven products that generate content, design, and solutions.',
    icon: '🧠',
  },
  {
    id: 4,
    title: 'BI Dashboards',
    description: 'Designing and developing interactive business intelligence dashboards for data visualization.',
    icon: '📈',
  },
  {
    id: 5,
    title: 'Report Writing',
    description: 'Crafting detailed and professional reports to present data findings and business insights.',
    icon: '📝',
  },
  {
    id: 6,
    title: 'Research',
    description: 'Conducting thorough research to support academic, business, and product development projects.',
    icon: '🔍',
  },
];

const Services = () => {
  return (
    <div className="bg-black text-white p-8">
      <h1 className="text-5xl md:text-6xl font-bold mb-8 text-center">Services</h1>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8 mb-16">
        {services.map((service) => (
          <div key={service.id} className="p-4 border border-gray-800 rounded-lg transition-transform duration-500 hover:scale-105">
            <div className="text-6xl mb-4">{service.icon}</div>
            <h2 className="text-3xl md:text-4xl font-bold mb-4 hover:text-green-500 transition-all duration-700 hover:underline">{service.title}</h2>
            <p className="text-lg md:text-xl">{service.description}</p>
          </div>
        ))}
      </div>
      {/* Contact Section */}
      <ContactSection />
    </div>
  );
};

export default Services;
